import { AppError } from './AppError';

/**
 * Error thrown when a resource is not found.
 */
export class NotFoundError extends AppError {
  /**
   * Creates a new NotFoundError instance.
   * @param message The error message.
   * @param resource The resource that was not found.
   * @param identifier The identifier that was used to look up the resource.
   */
  constructor(
    message: string = 'Resource not found',
    resource?: string,
    identifier?: string | number
  ) {
    const formattedMessage = resource && identifier
      ? `${message}: ${resource} with identifier ${identifier}`
      : message;
    
    super(formattedMessage, 'NOT_FOUND', true, { resource, identifier });
    this.name = 'NotFoundError';
  }

  /**
   * Creates a NotFoundError for a specific resource and identifier.
   * @param resource The resource that was not found.
   * @param identifier The identifier that was used to look up the resource.
   * @returns A new NotFoundError instance.
   */
  static forResource(resource: string, identifier: string | number): NotFoundError {
    return new NotFoundError(undefined, resource, identifier);
  }
}